import React, { useEffect, useMemo } from "react"
import { useClearRefinements, useInstantSearch, useRefinementList } from "react-instantsearch"
import Pill from "./pill/pill";
import { container } from './pill-menu.module.css'
import { CalculatorIcon, NewIcon, PodcastIcon, TrendingIcon, VideoIcon, WhitepaperIcon } from "../icons"

const PillMenu = ({ attribute, operator = 'and', transformItems, ...props }) => {
    const { items, refine } = useRefinementList({ attribute, operator, transformItems });
    const { refine: clearPills } = useClearRefinements({ includedAttributes: ['pillTypes'] })
    const { uiState } = useInstantSearch()

    useEffect(() => {
        const hasQuery = !!uiState['contentful-entries'].query;
        const hasMenu = !!uiState['contentful-entries'].menu;
        const hasPills = !!uiState['contentful-entries'].refinementList?.pillTypes.length > 0;


        // If pills have been chosen and query and menu are empty
        if (hasPills && !hasQuery && !hasMenu) {
            clearPills();
        }
    }, [uiState['contentful-entries'].query,
    uiState['contentful-entries'].menu,
    uiState['contentful-entries'].refinementList])



    if (!uiState['contentful-entries'].query && !uiState['contentful-entries'].menu) {
        return null;
    }

    return (
        <div className={container} {...props}>
            {items.map((item) => {
                let icon;

                switch (item.value) {
                    case 'Calculator':
                        icon = CalculatorIcon;
                        break;
                    case 'Trending':
                        icon = TrendingIcon;
                        break;
                    case 'Nieuw':
                        icon = NewIcon;
                        break;
                    case 'Podcast':
                        icon = PodcastIcon;
                        break;
                    case 'Video':
                        icon = VideoIcon;
                        break;
                    case 'Whitepaper':
                        icon = WhitepaperIcon;
                        break;
                    default:
                        break;
                }
                return (
                    <Pill key={item.value} icon={icon} isActive={item.isRefined} label={item.label} onClick={() => refine(item.value)} />
                )
            })}
        </div>
    )
}

export default PillMenu
